import React from 'react'
import './experiencia.css'

function Experiencia(){
    return <div className="exp">
        <div className="exp2">
        <h1>Experiencia</h1>
        <p>Desarrollo WEB de diversos proyectos realizados en el Bootcamp "UCAMP" realizado por la universidad UTEL utilizando diferentes tecnologías y frameworks como los siguientes:</p> 
            <ul>
            <li>HTML</li>
            <li>CSS</li>
            <li>JAVASCRIPT</li>
            <li>REACT</li>
            <li>MONGO DB</li>
            <li>EXPRESS</li>
            <li>NODE</li>
            </ul>
            <p>Te invito a visitar la sección de proyectos donde podrás encontrar las aplicaciones que fueron desarrolladas a lo largo de este bootcamp.</p> 
        </div>


        </div>
        

    
}

export { Experiencia }